import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconGifOutline",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5v-7ZM2.5 2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7Zm0 4A1.5 1.5 0 0 1 4 4.5h.5a.5.5 0 1 1 0 1H4a.5.5 0 0 0-.5.5v.5A.5.5 0 0 0 4 7v-.316a.5.5 0 0 1 .25-.934h.25a.5.5 0 0 1 .5.5V7.5a.5.5 0 0 1-.5.5H4a1.5 1.5 0 0 1-1.5-1.5V6ZM6 4.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 1 1-1 0V5a.5.5 0 0 1 .5-.5ZM7 5a.5.5 0 0 1 .5-.5H9a.5.5 0 1 1 0 1H8v.25h.5a.5.5 0 1 1 0 1H8v.75a.5.5 0 1 1-1 0V5Z",
  fill: "currentColor"
}, null, -1), u = [
  _
];
function h(e, m, i, f, v, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--gif-outline"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Gif Outline",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const b = /* @__PURE__ */ o(s, [["render", h]]);
export {
  b as default
};
//# sourceMappingURL=gif-outline.js.map
